<template>
  <div
    v-if="errorMessage"
    class="error-message"
  >
    <span>{{ errorMessage }}</span>
  </div>
</template>

<script>
export default {
  props: {
    errorMessage: {
      type: String,
      default: "",
    },
  },
};
</script>

<style scoped>
.error-message {
  color: red;
  font-size: 0.875rem;
  margin-top: -5px; /* Adjust as needed */
}
</style>
